import { Modal } from "@circle-react-uikit/ModalV2";
import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";
import { planActions } from "@/react/helpers/plansHelpers";

import { ContactSupport } from "../ContactSupport";
import { useFetchProration } from "../hooks/useFetchProration";
import { Loader } from "../Loader";
import { useUpgradePlanContext } from "../UpgradePlanContext";
import { UpgradePlanModalBody } from "../UpgradePlanModalBody";
import { UpgradePlanModalFooter } from "../UpgradePlanModalFooter";
import { UpgradePlanModalHeader } from "../UpgradePlanModalHeader";
import { Details } from "./Details";
import { TotalDue } from "./TotalDue";

const i18nRoot = "pricing_plans.upgrade_modal";

interface ProrationProps {
  hideModal: () => void;
  onSubmitHandler: () => void;
}

export const Proration = ({ hideModal, onSubmitHandler }: ProrationProps) => {
  const { plan, couponId: planCouponId } = useUpgradePlanContext();
  const { prorationData, isProrationLoading, errorFetchingProration } =
    useFetchProration({
      new_plan_id: plan.id,
      plan_coupon_id: planCouponId,
    });

  if (isProrationLoading) {
    return <Loader title={t([i18nRoot, "loading.proration"])} />;
  }

  if (errorFetchingProration) {
    return (
      <ContactSupport
        title={t([i18nRoot, "errors.calculating_proration.title"])}
        errorMessage={t([i18nRoot, "errors.calculating_proration.message"])}
      />
    );
  }

  return (
    <>
      <UpgradePlanModalHeader title={t("pricing_plans.change_plan.title")}>
        <Modal.Title>{t("pricing_plans.change_plan.title")}</Modal.Title>
        <Modal.HeaderActions>
          <Modal.CloseButton onClick={hideModal} />
        </Modal.HeaderActions>
      </UpgradePlanModalHeader>
      <UpgradePlanModalBody>
        <Details prorationData={prorationData} />
        <TotalDue totalDue={prorationData?.display_total_due_today} />
      </UpgradePlanModalBody>
      <UpgradePlanModalFooter
        className="mt-5"
        layout="full-width"
        primaryAction={{
          label: t(`pricing_plans.actions.${planActions.change_plan}`),
          onClick: onSubmitHandler,
        }}
      >
        <Button variant="primary" size="lg" fullWidth onClick={onSubmitHandler}>
          {t(`pricing_plans.actions.${planActions.change_plan}`)}
        </Button>
      </UpgradePlanModalFooter>
    </>
  );
};
